import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchVersions, type FetchVersionsParams } from '../../api/fetchers/versions/fetcher';

interface FetchVersionsActionParams extends FetchVersionsParams {
  essential: boolean;
}

export const fetchVersionsAction = createAsyncThunk('versions/fetchVersions', (params: FetchVersionsActionParams) =>
  fetchVersions(params)
);
